import { useParams } from "react-router-dom";
import { useFetchSeason } from "~hooks/apiHooks/useFetchSeason";
import type { Season, SeasonResources, SeasonResponse } from "~types/season";

export const useGetSeasonFixtureProfile = () => {
  const { seasonId } = useParams();
  const { data: seasonFixtureProfile, isLoading: isSeasonLoading } = useFetchSeason(
    seasonId,
    {
      include: ["fixtureProfiles"].toString(),
    },
    (response: SeasonResponse) => {
      const season: Season | undefined = response?.data?.[0];
      const resources: SeasonResources | undefined = response.includes?.resources;
      return resources?.fixtureProfiles?.[season?.profileId ?? ""];
    },
  );

  return { seasonFixtureProfile, isSeasonLoading };
};
